var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.834,
    height: 14.836,
    viewBox: "0 0 14.834 14.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M18.648,2.334a.637.637,0,0,1,0,.9L17.32,4.563,14.773,2.016,16.1.686a.637.637,0,0,1,.9,0l1.647,1.647ZM16.42,5.462,13.873,2.915,5.2,11.593a.637.637,0,0,0-.154.25L4.016,14.917a.318.318,0,0,0,.4.4l3.074-1.025a.637.637,0,0,0,.25-.153L16.42,5.463Z",
    transform: "translate(-4 -0.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.4888bba15d7fa8942c3f525de8c38b6c.svg";
export { ForwardRef as ReactComponent };